import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import withShowHide from '@sparefoot/react-core/decorators/withShowHide';
import CSSTransition from 'react-transition-group/CSSTransition';

import './Tooltip.scss';

export const enhance = withShowHide('tooltip');

export function Tooltip({
	children,
	className,
	content,
	onShowTooltip,
	onHideTooltip,
	tooltipShowing,
	last,
}) {
	const handleTooltipClick = (event) => {
		event.stopPropagation();
		event.preventDefault();
	};

	return (
		<div
			className={classnames('ss-tooltip', className, {
				last,
			})}
		>
			{/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
			<div
				className="tooltip-trigger"
				onMouseEnter={onShowTooltip}
				onMouseLeave={onHideTooltip}
				onClick={handleTooltipClick}
			>
				{children}
			</div>
			<CSSTransition
				in={tooltipShowing}
				timeout={300}
				classNames="transition-fade-in"
				unmountOnExit
			>
				<div className="tooltip-content">{content}</div>
			</CSSTransition>
		</div>
	);
}

Tooltip.propTypes = {
	content: PropTypes.node.isRequired,
	className: PropTypes.string,
	children: PropTypes.node,
	onShowTooltip: PropTypes.func.isRequired,
	onHideTooltip: PropTypes.func.isRequired,
	tooltipShowing: PropTypes.bool,
	last: PropTypes.bool,
};

export default enhance(Tooltip);
